<template>
  <div v-show="Object.keys(chart).length">
    <div class="row mb-5">
      <div v-show="chart.sales" class="col-12 col-md-6">
        <div class="card">
          <div class="card-body widget-chat-wrapper-outer">
            <canvas id="sales-chart" class="mb-5" ref="salesChart"></canvas>
          </div>
        </div>
      </div>
      <div v-show="chart.refuse" class="col-12 col-md-6">
        <div class="card">
          <div class="card-body widget-chat-wrapper-outer">
            <canvas id="refuse-chart" class="mb-5" ref="refuseChart"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Chart from 'chart.js/auto'
export default {
  data() {
    return {
      chartEl: {}
    }
  },
  computed: {
    data() {
      return this.config
    },
    chart() {
      return Object.assign({}, this.data?.chart)
    }
  },
  methods: {
    initChart() {
      let el = ['sales', 'refuse']
      el.forEach((elem) => {
        this.handleChart(elem, this.chart[elem])
      })
    },
    handleChart: function (elem, _data) {
      if (_.isObjectLike(_data)) {
        let data = {
          type: _data?.type || 'bar',
          data: {
            datasets: {},
            labels: []
          },
          options: {
            responsive: true,
            hoverMode: 'index',
            stacked: false,
            elements: {
              line: {
                tension: 0.0001
              }
            },
            scales: {
              x: {},
              y: {},
              y1: {}
            },
            animation: {
              onComplete: () => {
                if (this.chartEl?.[elem]?.chartRendered) {
                  this.chartEl[elem].resize()
                  this.chartEl[elem].chartRendered = true
                }
              }
            }
          }
        }

        let temp = {
          axis: []
        }

        for (const [name, items] of Object.entries(_data.data)) {
          data.data.datasets[name] = {
            label: name + (!_.isUndefined(items.unit) ? ' (' + items.unit + ')' : ''),
            data: [],
            backgroundColor: [],
            borderColor: []
          }
          if (!_.isUndefined(items.type)) {
            data.data.datasets[name].type = items.type
          }

          if (_.isUndefined(items.color)) {
            items.color = ''
          }
          if (!_.isUndefined(items.fill)) {
            data.data.datasets[name].fill = items.fill
          }
          if (!_.isUndefined(items.stack)) {
            data.data.datasets[name].stack = items.stack
          }

          items.type = items.type || data.type

          items.background = items.background || items.color
          items.border = items.border || items.color

          if (!_.isUndefined(items.axis)) {
            if (['top', 'bottom'].indexOf(items.axis) != -1) {
              data.data.datasets[name].x = items.axis
            } else if (['left', 'right'].indexOf(items.axis) != -1) {
              data.data.datasets[name].y = items.axis
            }
            if (temp.axis.indexOf(items.axis) == -1) {
              temp.axis.push(items.axis)
            }
          }

          for (const [, object] of Object.entries(items.data)) {
            if (data.data.labels.indexOf(object.label) == -1) {
              data.data.labels.push(object.label)
            }
          }
        }

        for (const [name, items] of Object.entries(_data.data)) {
          let color
          let background
          let border
          Object.entries(items.data).forEach(([, item]) => {
            if (_.isObjectLike(item)) {
              data.data.datasets[name].data.push(item.value || '')
              color = item.color || items.color
              background = item.background || color
              border = item.border || color
            } else {
              data.data.datasets[name].data.push(item)
              background = items.background
              border = items.border
            }
          })
          data.data.datasets[name].backgroundColor.push(background)
          data.data.datasets[name].borderColor.push(border)
          if (items.type == 'line') {
            data.data.datasets[name].backgroundColor = data.data.datasets[name].backgroundColor[0]
            data.data.datasets[name].borderColor = data.data.datasets[name].borderColor[0]
          }
        }

        temp.axis.forEach(function (item) {
          item = {
            display: true,
            position: item,
            id: item,
            gridLines: {
              display: false
            },
            ticks: {
              beginAtZero: true
            }
          }
          switch (item.position) {
            case 'bottom':
              data.options.scales.x = item
              break
            case 'left':
              data.options.scales.y = item
              break
            case 'right':
              data.options.scales.y1 = item
              break
          }
        })

        data.data.datasets = Object.values(data.data.datasets)

        data.options = Object.assign(data.options, _data.options || {})

        if (this.chartEl[elem] != undefined) {
          this.chartEl[elem].destroy()
        }
        this.chartEl[elem] = new window.Chart(this.$refs[elem + 'Chart'], data)
        this.$refs[elem + 'Chart'].style.display = 'block'
      } else {
        this.$refs[elem + 'Chart'].style.display = 'none'
      }
    }
  },
  props: {
    config: Object
  },
  watch: {
    chart() {
      this.initChart()
    }
  }
}
</script>
